import type { ColDef } from 'ag-grid-community';
import { editableContentCellRendererFactory } from 'components/shared/Blotter/Grid/CellRenderers/EditableContentCellRenderer';
import { useMemo } from 'react';
import { getEditInfoForProductField } from 'state/secondaryMarket/productSearch/productSearch.selectors';

export function useEditableStringColumnType(largeText?: boolean): ColDef {
  return useMemo(
    () => ({
      cellEditor: largeText ? 'agLargeTextCellEditor' : 'agTextCellEditor',
      cellEditorParams: { maxLength: 1000 },
      cellEditorPopup: largeText,
      cellRenderer: editableContentCellRendererFactory(getEditInfoForProductField),
    }),
    [largeText],
  );
}
